// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/survey.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/survey.proto.
 */
export const file_v1_survey: GenFile = /*@__PURE__*/
  fileDesc("Cg92MS9zdXJ2ZXkucHJvdG8SAnYxIjEKFFN1cnZleVF1ZXN0aW9uT3B0aW9uEgoKAmlkGAEgASgFEg0KBWxhYmVsGAIgASgJIo0BCg5TdXJ2ZXlRdWVzdGlvbhIKCgJpZBgBIAEoBRINCgVsYWJlbBgCIAEoCRIjCgthbnN3ZXJfdHlwZRgDIAEoDjIOLnYxLkFuc3dlclR5cGUSEAoIcmVxdWlyZWQYBCABKAgSKQoHb3B0aW9ucxgFIAMoCzIYLnYxLlN1cnZleVF1ZXN0aW9uT3B0aW9uIl8KBlN1cnZleRIKCgJpZBgBIAEoBRINCgV0aXRsZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIlCglxdWVzdGlvbnMYBCADKAsyEi52MS5TdXJ2ZXlRdWVzdGlvbiIZChdHZXRQZW5kaW5nU3VydmV5UmVxdWVzdCJKChhHZXRQZW5kaW5nU3VydmV5UmVzcG9uc2USEgoKaGFzX3N1cnZleRgBIAEoCBIaCgZzdXJ2ZXkYAiABKAsyCi52MS5TdXJ2ZXkiUAoRU3VydmV5QW5zd2VySW5wdXQSEwoLcXVlc3Rpb25faWQYASABKAUSEgoKdGV4dF92YWx1ZRgCIAEoCRISCgpvcHRpb25faWRzGAMgAygFIlgKG1N1Ym1pdFN1cnZleVJlc3BvbnNlUmVxdWVzdBIRCglzdXJ2ZXlfaWQYASABKAUSJgoHYW5zd2VycxgCIAMoCzIVLnYxLlN1cnZleUFuc3dlcklucHV0IkAKHFN1Ym1pdFN1cnZleVJlc3BvbnNlUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJKnAKCkFuc3dlclR5cGUSGwoXQU5TV0VSX1RZUEVfVU5TUEVDSUZJRUQQABIUChBBTlNXRVJfVFlQRV9URVhUEAESFQoRQU5TV0VSX1RZUEVfUkFESU8QAhIYChRBTlNXRVJfVFlQRV9DSEVDS0JPWBADMr0BCg1TdXJ2ZXlTZXJ2aWNlEk8KEEdldFBlbmRpbmdTdXJ2ZXkSGy52MS5HZXRQZW5kaW5nU3VydmV5UmVxdWVzdBocLnYxLkdldFBlbmRpbmdTdXJ2ZXlSZXNwb25zZSIAElsKFFN1Ym1pdFN1cnZleVJlc3BvbnNlEh8udjEuU3VibWl0U3VydmV5UmVzcG9uc2VSZXF1ZXN0GiAudjEuU3VibWl0U3VydmV5UmVzcG9uc2VSZXNwb25zZSIAQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM");

/**
 * SurveyQuestionOption is one choice of a radio or checkbox question.
 *
 * @generated from message v1.SurveyQuestionOption
 */
export type SurveyQuestionOption = Message<"v1.SurveyQuestionOption"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message v1.SurveyQuestionOption.
 * Use `create(SurveyQuestionOptionSchema)` to create a new message.
 */
export const SurveyQuestionOptionSchema: GenMessage<SurveyQuestionOption> = /*@__PURE__*/
  messageDesc(file_v1_survey, 0);

/**
 * SurveyQuestion is one question of a survey, as shown to a user.
 *
 * @generated from message v1.SurveyQuestion
 */
export type SurveyQuestion = Message<"v1.SurveyQuestion"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: v1.AnswerType answer_type = 3;
   */
  answerType: AnswerType;

  /**
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * options is empty for ANSWER_TYPE_TEXT.
   *
   * @generated from field: repeated v1.SurveyQuestionOption options = 5;
   */
  options: SurveyQuestionOption[];
};

/**
 * Describes the message v1.SurveyQuestion.
 * Use `create(SurveyQuestionSchema)` to create a new message.
 */
export const SurveyQuestionSchema: GenMessage<SurveyQuestion> = /*@__PURE__*/
  messageDesc(file_v1_survey, 1);

/**
 * Survey is a survey as shown to a user, questions in display order.
 *
 * @generated from message v1.Survey
 */
export type Survey = Message<"v1.Survey"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated v1.SurveyQuestion questions = 4;
   */
  questions: SurveyQuestion[];
};

/**
 * Describes the message v1.Survey.
 * Use `create(SurveySchema)` to create a new message.
 */
export const SurveySchema: GenMessage<Survey> = /*@__PURE__*/
  messageDesc(file_v1_survey, 2);

/**
 * @generated from message v1.GetPendingSurveyRequest
 */
export type GetPendingSurveyRequest = Message<"v1.GetPendingSurveyRequest"> & {
};

/**
 * Describes the message v1.GetPendingSurveyRequest.
 * Use `create(GetPendingSurveyRequestSchema)` to create a new message.
 */
export const GetPendingSurveyRequestSchema: GenMessage<GetPendingSurveyRequest> = /*@__PURE__*/
  messageDesc(file_v1_survey, 3);

/**
 * @generated from message v1.GetPendingSurveyResponse
 */
export type GetPendingSurveyResponse = Message<"v1.GetPendingSurveyResponse"> & {
  /**
   * has_survey is false when nothing should be shown; survey is then unset.
   *
   * @generated from field: bool has_survey = 1;
   */
  hasSurvey: boolean;

  /**
   * @generated from field: v1.Survey survey = 2;
   */
  survey?: Survey;
};

/**
 * Describes the message v1.GetPendingSurveyResponse.
 * Use `create(GetPendingSurveyResponseSchema)` to create a new message.
 */
export const GetPendingSurveyResponseSchema: GenMessage<GetPendingSurveyResponse> = /*@__PURE__*/
  messageDesc(file_v1_survey, 4);

/**
 * SurveyAnswerInput carries one question's answer.
 *
 * @generated from message v1.SurveyAnswerInput
 */
export type SurveyAnswerInput = Message<"v1.SurveyAnswerInput"> & {
  /**
   * @generated from field: int32 question_id = 1;
   */
  questionId: number;

  /**
   * text_value is used for ANSWER_TYPE_TEXT and ignored otherwise.
   *
   * @generated from field: string text_value = 2;
   */
  textValue: string;

  /**
   * option_ids holds exactly one id for ANSWER_TYPE_RADIO and zero or more
   * for ANSWER_TYPE_CHECKBOX. Ignored for ANSWER_TYPE_TEXT.
   *
   * @generated from field: repeated int32 option_ids = 3;
   */
  optionIds: number[];
};

/**
 * Describes the message v1.SurveyAnswerInput.
 * Use `create(SurveyAnswerInputSchema)` to create a new message.
 */
export const SurveyAnswerInputSchema: GenMessage<SurveyAnswerInput> = /*@__PURE__*/
  messageDesc(file_v1_survey, 5);

/**
 * @generated from message v1.SubmitSurveyResponseRequest
 */
export type SubmitSurveyResponseRequest = Message<"v1.SubmitSurveyResponseRequest"> & {
  /**
   * @generated from field: int32 survey_id = 1;
   */
  surveyId: number;

  /**
   * @generated from field: repeated v1.SurveyAnswerInput answers = 2;
   */
  answers: SurveyAnswerInput[];
};

/**
 * Describes the message v1.SubmitSurveyResponseRequest.
 * Use `create(SubmitSurveyResponseRequestSchema)` to create a new message.
 */
export const SubmitSurveyResponseRequestSchema: GenMessage<SubmitSurveyResponseRequest> = /*@__PURE__*/
  messageDesc(file_v1_survey, 6);

/**
 * @generated from message v1.SubmitSurveyResponseResponse
 */
export type SubmitSurveyResponseResponse = Message<"v1.SubmitSurveyResponseResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.SubmitSurveyResponseResponse.
 * Use `create(SubmitSurveyResponseResponseSchema)` to create a new message.
 */
export const SubmitSurveyResponseResponseSchema: GenMessage<SubmitSurveyResponseResponse> = /*@__PURE__*/
  messageDesc(file_v1_survey, 7);

/**
 * AnswerType is how a question's answer is captured.
 *
 * @generated from enum v1.AnswerType
 */
export enum AnswerType {
  /**
   * @generated from enum value: ANSWER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ANSWER_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: ANSWER_TYPE_RADIO = 2;
   */
  RADIO = 2,

  /**
   * @generated from enum value: ANSWER_TYPE_CHECKBOX = 3;
   */
  CHECKBOX = 3,
}

/**
 * Describes the enum v1.AnswerType.
 */
export const AnswerTypeSchema: GenEnum<AnswerType> = /*@__PURE__*/
  enumDesc(file_v1_survey, 0);

/**
 * SurveyService exposes the two operations a regular user needs: learn whether
 * a survey should be shown right now, and answer it. Authoring lives in
 * AdminSurveyService.
 *
 * @generated from service v1.SurveyService
 */
export const SurveyService: GenService<{
  /**
   * GetPendingSurvey returns the one survey this user should see now.
   *
   * SIDE EFFECT: when a survey is returned, its prompt is recorded
   * (prompt_count incremented, last_prompted_at set to now) in the same
   * transaction as the read. Calling this twice in a row therefore returns a
   * survey at most once, which is what keeps a page reload from re-opening
   * the dialog.
   *
   * @generated from rpc v1.SurveyService.GetPendingSurvey
   */
  getPendingSurvey: {
    methodKind: "unary";
    input: typeof GetPendingSurveyRequestSchema;
    output: typeof GetPendingSurveyResponseSchema;
  },
  /**
   * SubmitSurveyResponse stores this user's answers. One response per user
   * per survey; a second call is rejected.
   *
   * @generated from rpc v1.SurveyService.SubmitSurveyResponse
   */
  submitSurveyResponse: {
    methodKind: "unary";
    input: typeof SubmitSurveyResponseRequestSchema;
    output: typeof SubmitSurveyResponseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_survey, 0);

